// extracted by mini-css-extract-plugin
export default {"terms":"Terms_terms__ph-Vf","steps":"Terms_steps__810RW"};